import { gql } from "@apollo/client";

const CONFIG_DEDUCTION_SLA_CONFIG_FIELDS = `
  id
  configKey
  configValue
  description
`;

export const GET_CONFIG_DEDUCTION_SLA_CONFIGS = gql`
  query ConfigDeductionSlaConfigs($params: ConfigDeductionSlaConfigsParamsInput!) {
    configDeductionSlaConfigs(params: $params) {
      total
      page
      limit
      items {
        ${CONFIG_DEDUCTION_SLA_CONFIG_FIELDS}
      }
    }
  }
`;

export const UPDATE_CONFIG_DEDUCTION_SLA_CONFIG = gql`
  mutation UpdateConfigDeductionSlaConfig(
    $params: UpdateConfigDeductionSlaConfigInput!
  ) {
    updateConfigDeductionSlaConfig(params: $params) {
      ${CONFIG_DEDUCTION_SLA_CONFIG_FIELDS}
    }
  }
`;
